import React from "react";
import PropTypes from "prop-types";

import ReadOnlyPanel from "editor/components/ReadOnlyPanel";
import Icon from "components/library/Icon";

import styles from "./LockedContentPanel.css";
import Embargo from "editor/components/Embargo";
import isDateNotInPast from "editor/utils/isDateNotInPast";

export default function LockedContentPanel(props) {
  let description;
  let button = "Start writing";

  if (props.lock && props.lock.locked_by_me === false) {
    description = (
      <span>
        <Icon name="lock" className={styles.icon} />
        {props.lock.locked_by} is editing this. Do you want to kick them out?
      </span>
    );
    button = "Kick them out";
  } else if (
    (!props.lock || (props.lock && !props.lock.locked_by_me)) &&
    !props.isNewStory
  ) {
    description =
      props.form && isDateNotInPast(props.form.embargo_until, "minute") ? (
        <span>
          <Embargo form={props.form} />.
        </span>
      ) : (
        <span>Do you want to make changes?</span>
      );
  }

  return (
    <ReadOnlyPanel
      isVisible={!!description}
      description={description}
      button={button}
      onClick={props.lockContent}
    />
  );
}

LockedContentPanel.propTypes = {
  lock: PropTypes.shape({
    locked_by_me: PropTypes.bool,
  }),
  lockContent: PropTypes.func.isRequired,
  isNewStory: PropTypes.bool.isRequired,
  form: PropTypes.object.isRequired,
};
